import type { FaireProductEntity } from "../../entity_types/product";

export const p_mnc2gjxtxm: FaireProductEntity = {
  token: "p_mnc2gjxtxm",
  type: "product",
  name: "Pink Halo Moissanite Engagement Ring in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/5809698f31ec4125ffd4a77da97926a09ae9266bb06b033cf4eff7c43a93fabc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d3a2ef66aa02e924bf7dbcc983310926bf657d1700871e8d320ec1e2155b481.jpeg",
    "https://cdn.faire.com/fastly/ac2d506437f5c521595abc66030188bdb60b791a75d0629e8157ac29063ac8b8.jpeg",
    "https://cdn.faire.com/fastly/26aaf67684a9462512385dd78f42f8efac24af2652318a00551b1efe276a3492.jpeg",
    "https://cdn.faire.com/fastly/80129777923ff6db70fe8ed65822f4ecab54164407961c1ef11bd831797d0534.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "Description & Details\n\nWhere diamonds symbolize tradition and stability, moissanite is a metaphor for youthfulness, effervescence and the journey of our endeavors.\n\n• Material: Solid 925 Sterling Silver ∙ Certified Moissanite (Color D, VVS1)\n• Finish: Hypoallergenic ∙ 950 Platinum (Pt 950) Plating\n• Dimensions: 1.0 ct, Color D, VVS1 Moissanite, US size 4 1/2 - 9 available\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:25.681Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
